var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1 4.5 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19.73a5 5 0 0 0 .725-9.948A7.004 7.004 0 0 0 6.22 7.78 6.001 6.001 0 0 0 7 19.73h11Zm3-5a3 3 0 0 1-3 3H7a4 4 0 0 1-.16-7.997l.55-.021.276-.478a5.002 5.002 0 0 1 9.264 1.662l.144.852.863-.017H18a3 3 0 0 1 3 3Z",
    fill: "currentColor"
  })));
};
export default SvgCloud;